import { jwtDecode } from 'jwt-decode'
import { toSafeInteger } from 'lodash'

import { createSocket, disconnectSocket, globalErrorHandler, projectName } from '@/utils'

const key = `${projectName}:token`
let timer = false

/**
 * Разбирает JWT-токен.
 *
 * @param {string} token Токен из хранилища или из ответа бэкенда.
 * @returns {object|undefined} Полезная нагрузка токена или `undefined`, если токен не разбирается.
 */
function decodeToken(token) {
  try {
    return jwtDecode(token)
  } catch {
    return undefined
  }
}

/**
 * Переводит приложение в состояние гостя: снимает таймер выхода, очищает
 * аккаунт и отключает сокет.
 *
 * @param {object} context Контекст действия Vuex.
 * @param {Function} context.dispatch Отправка действий Vuex.
 */
function setGuestState({ dispatch }) {
  if (timer) {
    clearInterval(timer)
  }

  dispatch('account/setAccount', false, { root: true })

  disconnectSocket()
}

export default {
  namespaced: true,

  state: {
    token: false
  },

  mutations: {
    setToken(state, token) {
      if (token) {
        window.localStorage.setItem(key, token)
        state.token = token
      } else {
        window.localStorage.removeItem(key)
        state.token = false
      }
    }
  },

  actions: {
    setTimer({ state, dispatch }) {
      if (timer) {
        clearInterval(timer)
      }
      timer = setInterval(() => {
        if (state.token) {
          dispatch('login/logout', null, { root: true })
        }
        clearInterval(timer)
      }, 60 * 60 * 1000)
    },

    setToken({ commit }, token) {
      let decoded
      if (token) {
        const now = toSafeInteger(Date.now() / 1000)
        decoded = decodeToken(token)
        if (!decoded || now >= decoded.exp) {
          token = false
          decoded = undefined
        }
      }

      commit('setToken', token)

      return decoded
    },

    async setAccountFromToken({ commit, dispatch, state }) {
      if (!state.token) {
        setGuestState({ dispatch })

        return
      }

      const decoded = decodeToken(state.token)
      if (!decoded) {
        commit('setToken', false)
        setGuestState({ dispatch })

        return
      }

      await dispatch('setTimer')

      try {
        await dispatch('account/getAccount', decoded.id, { root: true })
      } catch (error) {
        commit('setToken', false)
        setGuestState({ dispatch })
        globalErrorHandler(error)

        return
      }

      createSocket()
    }
  },

  getters: {
    token: state => {
      return state.token
    }
  }
}
